export type EnquiryStatusFilterValue = 'open' | 'in_progress' | 'resolved';

export type EnquiryStatusDisplay = 'OPEN' | 'IN PROGRESS' | 'RESOLVED';
export type EnquiryTab = 'property-leads' | 'general-enquiries';

export const TAB_TO_API_TYPE: Record<
  EnquiryTab,
  'property_leads' | 'general_queries'
> = {
  'property-leads': 'property_leads',
  'general-enquiries': 'general_queries',
};

export const TABS: { key: EnquiryTab; label: string }[] = [
  { key: 'property-leads', label: 'Property Leads' },
  { key: 'general-enquiries', label: 'General Queries' },
];

export const STATUS_FILTER_OPTIONS: {
  value: EnquiryStatusFilterValue;
  label: string;
}[] = [
  { value: 'open', label: 'Open' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
];

export function formatEnquiryUpdatedAt(date: Date): string {
  return (
    date.toLocaleDateString('en-AU', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }) +
    ' | ' +
    date.toLocaleTimeString('en-AU', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    })
  );
}

export function mapApiStatusToDisplay(status: string): EnquiryStatusDisplay {
  switch (status) {
    case 'open':
      return 'OPEN';
    case 'in_progress':
      return 'IN PROGRESS';
    case 'resolved':
      return 'RESOLVED';
    default:
      return 'OPEN';
  }
}

export const INSPECTION_TYPE_LABEL_PRIVATE = 'Private Inspection' as const;
export const INSPECTION_TYPE_LABEL_PUBLIC = 'Public Inspection' as const;

export const ENQUIRY_TYPE_LABELS: Record<string, string> = {
  general_enquiry: 'General enquiry',
  document_request: 'Document request & building pest inspection',
  list_property: 'List property',
  get_valuation: 'Get valuation',
  property_valuation: 'Get valuation',
  listing_crm_enquiry: 'Property enquiry',
  open: 'Public Inspection',
  private: 'Private Inspection',
};

export function getEnquiryTypeLabel(
  enquiryType: string,
  inspectionType?: 'open' | 'private',
): string {
  if (inspectionType === 'private') {
    return ENQUIRY_TYPE_LABELS.private;
  }
  if (inspectionType === 'open') {
    return ENQUIRY_TYPE_LABELS.open;
  }
  return ENQUIRY_TYPE_LABELS[enquiryType] ?? enquiryType;
}

export const ENQUIRY_DETAIL_ACTION = {
  ADD_COMMENT: 'add_comment',
  MARK_RESOLVED: 'mark_resolved_success',
  SEND_DOCUMENTS: 'send_documents',
  CONFIRM_BOOKING: 'confirm_booking',
} as const;

export type EnquiryDetailActionId =
  (typeof ENQUIRY_DETAIL_ACTION)[keyof typeof ENQUIRY_DETAIL_ACTION];

export const ENQUIRY_DETAIL_ACTION_LABELS: Record<
  EnquiryDetailActionId,
  string
> = {
  [ENQUIRY_DETAIL_ACTION.ADD_COMMENT]: 'Reply',
  [ENQUIRY_DETAIL_ACTION.MARK_RESOLVED]: 'Mark As Resolved',
  [ENQUIRY_DETAIL_ACTION.SEND_DOCUMENTS]: 'Send Documents',
  [ENQUIRY_DETAIL_ACTION.CONFIRM_BOOKING]: 'Confirm Booking',
};
